"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HLQATasksBulkSelectionPanel = void 0;
var hlqa_tasks_bulk_selection_panel_component_1 = require("./hlqa-tasks-bulk-selection-panel.component");
Object.defineProperty(exports, "HLQATasksBulkSelectionPanel", { enumerable: true, get: function () { return hlqa_tasks_bulk_selection_panel_component_1.HLQATasksBulkSelectionPanel; } });
